import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/urls';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const useGetCouponById = ({ id }) => {

    const [couponById, setCouponById] = useState([]);
    const [totalPages, setTotalPages] = useState();
    const [loadingCoupon, setLoadingCoupon] = useState(true);
    const [errorCoupon, setErrorCoupon] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {

        const getCouponData = async () => {
            try {

                if (!id) return; 

                const res = await axios.get(`${BASE_URL}/coupon/${id}`, {
                    
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                    },
                  }); 
                  setCouponById(res.data); 
                  setTotalPages(res.data.totalPages)

                  if (!res.data.data || res.data.data.length === 0)  {
                    setErrorCoupon('Não Há cupons nem ofertas para essa id');
                  } else {
                    setErrorCoupon(null); 
                  }
                  
            } catch (err)  {
                navigate('/not-found')
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setErrorCoupon(msg);
            } finally {
                setLoadingCoupon(false)
            }
        }

        getCouponData();

    }, [id])
  

   return { couponById, loadingCoupon, errorCoupon, totalPages };
}

export default useGetCouponById